export default __webpack_public_path__ + "locales/vi/BackupCodesDialog.json?hash=a67e649e92841adfdac3bb46db7a8a6b";